import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetOffers } from './getOffers';
import { GetOffersById } from './getOfferById';
import { PostProductData } from './postProductData';
import { GetCollections } from './getCollections';
import { GetCategoryConfig } from './getCategoryConfig';
import { GetCategories } from './getCategories';
export const DependencyInjectionProductsInfrastructure = () => {
    container.register("iGetOffers", { useClass: GetOffers });
    container.register("iGetOffersById", { useClass: GetOffersById });
    container.register("iPostProductData", { useClass: PostProductData });
    container.register("iGetCollections", { useClass: GetCollections });
    container.register("iGetCategoryConfig", { useClass: GetCategoryConfig });
    container.register("iGetCategories", { useClass: GetCategories });
};
export default DependencyInjectionProductsInfrastructure;
